export default __webpack_public_path__ + "locales/pt-BR/PaymentsEnterprise.json?hash=e64e70faf18aade7c379d19844739d79";